// @core/api/endpoints/project/get_sprint.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  SprintResponse,
} from '../../../types/project';

const BASE_PATH = '/project';

/**
 * Get sprint
 * Retrieves sprint details including dates, goal, status, and summary of committed vs completed story points.
 */
export async function GetSprint(
  project_id: string,
  sprint_id: string,
  options?: RequestOptions
): Promise<SprintResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/projects/:project_id/sprints/:sprint_id`;
  requestPath = requestPath.replace(':project_id', encodeURIComponent(project_id));
  requestPath = requestPath.replace(':sprint_id', encodeURIComponent(sprint_id));
  const requestOptions = options;
  return client.get<SprintResponse>(requestPath, { ...requestOptions });
}
